/**
 * Amplify（Cognito）のセッションのグループ。スタッフのグループを 1 つでも持てば、patient-user を併せ持ってもスタッフとして扱う
 * （Issue #473。患者のフラグが ON なら、patient-user だけのセッションは未ログインと同じに扱う）。
 */

/** RoleRedirect がダッシュボードへ送るグループ（送る順も同じ）。 */
export const STAFF_GROUPS = [
  "ops-admin",
  "ops-operator",
  "clinic-doctor",
  "clinic-operator",
  "patient-admin",
  "health-nurse",
] as const;

type AmplifySessionLike = {
  tokens?: {
    idToken?: { payload?: unknown } | null;
    accessToken?: { payload?: unknown } | null;
  } | null;
} | null;

/** ID トークンか、無ければアクセストークンの cognito:groups（今の RoleGuard と同じ読み方）。 */
export function groupsOfAmplifySession(
  session: AmplifySessionLike | undefined,
): string[] {
  const idPayload = session?.tokens?.idToken
    ?.payload as Record<string, unknown> | undefined;
  const atPayload = session?.tokens?.accessToken
    ?.payload as Record<string, unknown> | undefined;
  const groups = (idPayload?.["cognito:groups"] ??
    atPayload?.["cognito:groups"]) as string | string[] | undefined;
  return Array.isArray(groups) ? groups : groups ? [String(groups)] : [];
}

export function hasStaffGroup(groups: readonly string[]): boolean {
  return groups.some((g) => (STAFF_GROUPS as readonly string[]).includes(g));
}

/** スタッフのグループを持たず、patient-user を持つ（切り替えの前の患者の Amplify のセッション）。 */
export function isPatientOnlyGroups(groups: readonly string[]): boolean {
  return !hasStaffGroup(groups) && groups.includes("patient-user");
}
